import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=7ca6d4bd&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ca6d4bd')) {
      api.createRecord('7ca6d4bd', component.options)
    } else {
      api.reload('7ca6d4bd', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=7ca6d4bd&", function () {
      api.rerender('7ca6d4bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2K89EFl6jvOKG/JS/offershelp.vue"
export default component.exports